module.exports = __webpack_public_path__ + "static/media/altri_servizi.2f2331fb.png";